export const LOAD_PROMO_IAP_SUCCESS = 'LOAD_PROMO_IAP_SUCCESS';
